module.exports = __webpack_public_path__ + "static/media/FestivalVision1.ba42b97a.jpg";